import React, { useState } from "react";
import Slider from "react-slick";
import useStyles, { FormInputSelect } from "./styles";
import Navbar2 from "../../components/Navbar2/Navbar2";
import Section from "../../components/Section/Section";
import Footer from "../../components/Footer/Footer";
import FormInputNoLabel from "../../components/FormInputNoLabel/FormInputNoLabel";
import Paragraph from "../../components/Typography/Paragraph";
import Card from "../../components/Card/Card";
import Loader from "react-js-loader";

import giftbox from "../../assets/images/giftbox.png";
import wallet from "../../assets/images/wallet.png";
import slot from "../../assets/images/slot.png";
import result from "../../assets/images/result.png";
import event from "../../assets/images/event.png";
import subscribe from "../../assets/images/subscribe.png";

import {
  Container,
  Grid,
  Table,
  TableContainer,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TablePagination,
  Stack,
  Checkbox,
  Dialog,
  DialogTitle,
  DialogContent,
} from "@mui/material";
import Button from "../../components/Button/Button";
import {
  AddCircle,
  MoreVert,
  Edit,
  Delete,
  RemoveCircle,
} from "@mui/icons-material";
import { get_razer_log, get_syn_log } from "../../API/API";
import Countdown from "react-countdown";
import moment from "moment/moment";

import "./styles.css";
import FormInput from "../../components/FormInput/FormInput";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-simple-toasts";

export default function Log() {
  const classes = useStyles();
  const navigate = useNavigate();
  const location = useLocation();

  const [sort, setSort] = React.useState(0);

  const handleChangeSort = (event) => {
    setSort(event.target.value);
  };

  const [searchKey, setSearchKey] = React.useState("");

  const [loading, setLoading] = useState(false);
  const [totalList, setTotalList] = React.useState(1);
  const [pageNum, setPageNum] = React.useState(0);

  const [listData, setlistData] = React.useState([]);

  // const [dateFrom, setDateFrom] = React.useState(moment().subtract(30, 'days').format("YYYY-MM-DD"));

  // const handleChangeDateFrom = (event) => {
  //   setDateFrom(event.target.value);
  // };

  // const [dateTo, setDateTo] = React.useState(moment().format("YYYY-MM-DD"));

  // const handleChangeDateTo = (event) => {
  //   setDateTo(event.target.value);
  // };

  const [dateFrom, setDateFrom] = React.useState(() => {
    const storedDateFrom = window.localStorage.getItem("datefrom");
    if (storedDateFrom) {
      return storedDateFrom;
    } else {
      return moment().subtract(30, "days").format("YYYY-MM-DD");
    }
  });

  const handleChangeDateFrom = (event) => {
    const value = event.target.value;
    setDateFrom(value);
    window.localStorage.setItem("datefrom", value);
  };

  const [dateTo, setDateTo] = React.useState(() => {
    const storedDateTo = window.localStorage.getItem("dateto");
    if (storedDateTo) {
      return storedDateTo;
    } else {
      return moment().format("YYYY-MM-DD");
    }
  });

  const handleChangeDateTo = (event) => {
    const value = event.target.value;
    setDateTo(value);
    window.localStorage.setItem("dateto", value);
  };

  const getData = () => {
    setLoading(true);
    get_syn_log({
      // page: pageNum + 1,
      dateFrom: dateFrom,
      dateTo: dateTo,
      // sort: sort
    }).then((json) => {
      setLoading(false);
      setlistData(json.data);
      setTotalList(json.total);
    });
  };

  React.useEffect(() => {
    getData();

    const storedDateFrom = window.localStorage.getItem("datefrom");
    if (storedDateFrom) {
      setDateFrom(storedDateFrom);
    }
    const storedDateTo = window.localStorage.getItem("dateto");
    if (storedDateTo) {
      setDateTo(storedDateTo);
    }
  }, [sort, dateFrom, dateTo]);

  const handleChangePage = (e, ispage) => {
    setPageNum(ispage);
    console.log(ispage);
    // getData();
  };

  const handleOpenVariantImage = (item) => {
    // console.log(e)
    setOpenVariantImg(true);
    setImageData(item.response);
  };

  const handleCloseVariantImage = (value) => {
    setOpenVariantImg(false);
    // setImageData(null);
  };

  const [imageData, setImageData] = React.useState(null);
  const [openVariantImg, setOpenVariantImg] = React.useState(false);
  const [infiniteStatus, setInfiniteStatus] = React.useState(true);

  const handleSearch = (event) => {
    setSearchKey(event.target.value);
    // setPageNum(0);
  };

  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  // filter rows based on search term
  const filteredRows = listData.filter((row) =>
    row.sales_order_id.toLowerCase().includes(searchKey.toLowerCase()) ||
    row.status.toLowerCase().includes(searchKey.toLowerCase())
  );

  return (
    <React.Fragment>
      {loading ? (
        <div style={{ margin: "auto" }}>
          <Loader type="bubble-loop" bgColor="#1A5386" size={50} />
        </div>
      ) : (
        <Navbar2
          children={
            <Section pd="2rem">
              <div>
                <div className={classes.theFlexHeader}>
                  <Paragraph color="#1A5386" bold="600" size="24px">
                    Sale Sync Status
                  </Paragraph>

                  <div
                    className={classes.theFlexBtn}
                    style={{ marginBottom: "0" }}
                  ></div>
                </div>
                <div
                  style={{
                    borderBottom: "2px solid #707070",
                    padding: ".2rem 0",
                  }}
                />
                <br />

                <div className={classes.theFlexAction}>
                  <div
                    className={classes.theWx}
                    style={{ margin: "0 20px 0 0" }}
                  >
                    <FormInputNoLabel
                      placeholder="Search"
                      border="1px solid #d7d7d7"
                      br="6px"
                      onChange={handleSearch}
                      value={searchKey}
                    />
                  </div>
                  <div>
                    <FormInputNoLabel
                      placeholder="Search"
                      border="1px solid #d7d7d7"
                      br="6px"
                      onChange={handleChangeDateFrom}
                      value={dateFrom}
                      type="date"
                    />
                  </div>
                  <Paragraph bold="bold" color="#707070" margin="0 1rem">
                    to
                  </Paragraph>
                  <div>
                    <FormInputNoLabel
                      placeholder="Search"
                      border="1px solid #d7d7d7"
                      br="6px"
                      onChange={handleChangeDateTo}
                      value={dateTo}
                      type="date"
                    />
                  </div>
                </div>

                <Grid container spacing={3}>
                  <Grid item xs={12} sm={12} md={12}>
                    <Card className={classes.theCard}>
                      <TableContainer>
                        <Table>
                          <TableHead style={{ backgroundColor: "#1A5386" }}>
                            <TableRow>
                              <TableCell
                                style={{ borderRadius: "10px 0 0 10px" }}
                                className={classes.theHeadTitle}
                              >
                                Sales Order ID
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Status
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Action
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Sale Rep
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Created Name
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Created Date
                              </TableCell>
                              <TableCell className={classes.theHeadTitle}>
                                Response
                              </TableCell>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {filteredRows
                              .slice(
                                pageNum * rowsPerPage,
                                pageNum * rowsPerPage + rowsPerPage
                              )
                              .map((item, index) => (
                                <TableRow>
                                  <a
                                    style={{ display: "contents" }}
                                    href={`../saledetail/${item.sales_order_id}`}
                                  >
                                    <TableCell
                                      style={{
                                        background:
                                          index % 2 == 0 ? "#f2f2f2" : "#fff",
                                        verticalAlign: "top",
                                      }}
                                    >
                                      {item.sales_order_id}
                                    </TableCell>

                                    <TableCell
                                      style={{
                                        background:
                                          index % 2 == 0 ? "#f2f2f2" : "#fff",
                                        verticalAlign: "top",
                                      }}
                                    >
                                      {item.status}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        background:
                                          index % 2 == 0 ? "#f2f2f2" : "#fff",
                                        verticalAlign: "top",
                                      }}
                                    >
                                      {item.action}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        background:
                                          index % 2 == 0 ? "#f2f2f2" : "#fff",
                                        verticalAlign: "top",
                                      }}
                                    >
                                      {item.salesrepname}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        background:
                                          index % 2 == 0 ? "#f2f2f2" : "#fff",
                                        verticalAlign: "top",
                                      }}
                                    >
                                      {item.createdname}
                                    </TableCell>
                                    <TableCell
                                      style={{
                                        background:
                                          index % 2 == 0 ? "#f2f2f2" : "#fff",
                                        verticalAlign: "top",
                                      }}
                                    >
                                      {item.created_date}
                                    </TableCell>
                                  </a>
                                  <TableCell
                                    style={{
                                      background:
                                        index % 2 == 0 ? "#f2f2f2" : "#fff",
                                      verticalAlign: "top",
                                    }}
                                  >
                                    <span
                                      onClick={() =>
                                        handleOpenVariantImage(item)
                                      }
                                      style={{
                                        textDecoration: "underline",
                                        color: "#1a5386",
                                      }}
                                    >
                                      View &#62;
                                    </span>
                                  </TableCell>
                                </TableRow>
                              ))}
                          </TableBody>
                        </Table>
                      </TableContainer>
                      <div
                        style={{
                          borderTop: "1px solid #707070",
                          borderBottom: "1px solid #707070",
                          margin: "1rem 0 0",
                          cursor: "pointer",
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "flex-end",
                        }}
                      >
                        <TablePagination
                          rowsPerPage={10}
                          rowsPerPageOptions={[10]}
                          component="div"
                          // count={filteredRows.length}
                          count={totalList}
                          page={pageNum}
                          onPageChange={handleChangePage}
                          // onChangeRowsPerPage={handleChangeRowsPerPage}
                        />
                      </div>
                    </Card>
                    <br />
                    <br />
                  </Grid>
                </Grid>
                <br />
                <br />
              </div>
            </Section>
          }
        />
      )}

      <Dialog
        onClose={handleCloseVariantImage}
        open={openVariantImg}
        fullWidth="true"
        maxWidth="xl"
      >
        <DialogTitle>
          {/* <Paragraph color="#1A5386" bold="600" size="24px">
              Attached Images
            </Paragraph> */}
        </DialogTitle>
        <DialogContent>
          <br />
          <div className={classes.theSliderVariant}>
            <Paragraph>{imageData}</Paragraph>
          </div>
          <br />
        </DialogContent>
      </Dialog>
    </React.Fragment>
  );
}
